import React from 'react';
export function Footer() {
  return <footer className="bg-pilates-dark text-white/70 py-10 px-4 text-center text-sm" data-id="element-113">
      <div className="max-w-3xl mx-auto space-y-4" data-id="element-114">
        <p data-id="element-115">© {new Date().getFullYear()} Pilates Ready. All Rights Reserved.</p>
        <p className="text-xs text-white/55 max-w-2xl mx-auto leading-relaxed" data-id="element-116">
          The content of this page is for informational and educational
          purposes. It does not replace certified professional training. Consult
          a health professional before starting any physical activity.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-2 text-xs text-white/60" data-id="element-117">
          <a href="#" className="hover:text-pilates-cream transition-colors" data-id="element-118">
            Terms & Conditions
          </a>
          <span data-id="element-119">·</span>
          <a href="#" className="hover:text-pilates-cream transition-colors" data-id="element-120">
            Privacy Policy
          </a>
          <span data-id="element-121">·</span>
          <a href="#" className="hover:text-pilates-cream transition-colors" data-id="element-122">
            Contact
          </a>
        </div>
      </div>
    </footer>;
}